import { app } from "../../Frame/App";
import { WidgetBase } from "./Widgets/WidgetBase";
import { BackgroundGridItem } from "./Components/BackgroundGridItem";
import { IWidgetLayout } from "./Server/IWidgetLayout";
import { IWidgetLayoutItem } from "./Server/IWidgetLayoutItem";
import { WidgetTypes } from "./Widgets/WidgetTypes";
import dom from "../../../dist/jsx-render/dom"
import { WidgetDragDrop } from "./Modules/WidgetDragDrop";
import { WidgetTable } from "./Widgets/WidgetTable";
import { WidgetAnalyse } from "./Widgets/WidgetAnalyse";
import { WidgetText } from "./Widgets/WidgetText";
import { WidgetImage } from "./Widgets/WidgetImage";
import { WidgetLinks } from "./Widgets/WidgetLinks";
import { WidgetWhoIsOnline } from "./Widgets/WidgetWhoIsOnline";
import { WidgetLists } from "./Widgets/WidgetLists";
import { WidgetDesignTable } from "./Widgets/WidgetDesignTable";
import { WidgetMeasureText } from "./Widgets/WidgetMeasureText";
import { WidgetDesignMeasureText } from "./Widgets/WidgetDesignMeasureText";
import { WidgetMeasuresByCategory } from "./Widgets/WidgetMeasuresByCategory";
import { IWidgetContext } from "./Components/EditRow/AvailableWidgets/IWidgetContext";
import { IWidgetSettings } from "./Components/EditRow/AvailableWidgets/IWidgetSettings";
import { WidgetStatistic } from "./Widgets/WidgetStatistic";
import { WidgetMeasureTree } from "./Widgets/WidgetMeasureTree";
import { WidgetMeasuresByStatus } from "./Widgets/WidgetMeasuresByStatus";
import { WidgetHasMeasures } from "./Widgets/WidgetHasMeasures";
import { WidgetGenericDataTable } from "./Widgets/WidgetGenericDataTable";
import { WidgetVideoTutorials } from "./Widgets/WidgetVideoTutorials";
import { WidgetDashboard } from "./Widgets/WidgetDashboard";
import { WidgetNewestDocuments } from "./Widgets/WidgetNewestDOcuments";
import { WidgetUserIsNamed } from "./Widgets/WidgetUserIsNamed";

//export const NUM_ROWS: number = 8;
//export const NUM_COLS: number = 5;

export class WidgetController {
    public NUM_ROWS: number = 8;
    public NUM_COLS: number = 8;

    public dragdrop: WidgetDragDrop;
    public container: HTMLElement;

    private bgWidgets: BackgroundGridItem[][];
    private widgets: WidgetBase[] = [];
    private widgetLayout: IWidgetLayout;
    private widgetSetting: IWidgetSettings;

    constructor(elementId: string, editButtonId: string, context: IWidgetContext, layout: IWidgetLayout = null) {
        // create controls
        let frame = document.getElementById(elementId);
        frame.classList.add("widget-frame");
        this.container = <div className="widget-container"></div>;

        if (!layout) {
            this.widgetLayout = JSON.parse((document.getElementById("WidgetLayout") as HTMLInputElement).value);
        } else {
            this.widgetLayout = layout;
        }

        if (this.widgetLayout && this.widgetLayout.height && this.widgetLayout.height != 100) {
            this.container.style.height = this.widgetLayout.height + "vh";
        }

        const inputWidgetSettings = document.getElementById("WidgetSettings") as HTMLInputElement;
        if (inputWidgetSettings && inputWidgetSettings.value.length > 0) {
            this.widgetSetting = JSON.parse(inputWidgetSettings.value);
        }

        context.handleEdit(editButtonId, frame, context, this.widgetLayout, this, this.widgetSetting);

        if (this.widgetLayout.rows) this.NUM_ROWS = this.widgetLayout.rows;
        if (this.widgetLayout.columns) this.NUM_COLS = this.widgetLayout.columns;

        frame.appendChild(this.container);

        this.container.style.gridTemplateRows = `repeat(${this.NUM_ROWS}, 1fr)`;
        this.container.style.gridTemplateColumns = `repeat(${this.NUM_COLS}, 1fr)`;

        this.dragdrop = new WidgetDragDrop(this, this.container);

        // create background grid items
        this.bgWidgets = [];
        for (let rowIndex = 1; rowIndex <= this.NUM_ROWS; rowIndex++) {
            this.bgWidgets[rowIndex - 1] = [];
            for (let colIndex = 1; colIndex <= this.NUM_COLS; colIndex++) {
                var gridItem = new BackgroundGridItem({ column: colIndex, row: rowIndex, controller: this });
                this.bgWidgets[rowIndex - 1].push(gridItem);
                this.container.appendChild(gridItem.render());
            }
        }

        this.load();
    }

    public setEditButtonEvent = (editButton: HTMLElement) => {

        if (editButton) {
            editButton.addEventListener("click", (ev: MouseEvent) => {
                ev.stopPropagation();
                ev.preventDefault();
                editButton.classList.add("d-none");
                this.startEdit();
            });
        }
    }

    public startEdit(): void {
        this.container.parentElement.classList.add("in-edit");
        for (let widget of this.widgets) {
            widget.enableEdit();
        }
    }

    public cancel(): void {
        this.container.parentElement.classList.remove("in-edit");
        this.load();
    }

    public load(): void {
        // delete all exisiting widgets
        for (let widget of this.widgets) {
            widget.component.element.parentElement.removeChild(widget.component.element);
        }
        this.widgets = [];

        if (this.widgetLayout.jsonString) {
            let items: IWidgetLayoutItem[] = JSON.parse(this.widgetLayout.jsonString);
            for (let item of items) {
                let widget = this.createWidget(item.type);
                widget.load(item);
                this.container.appendChild(widget.createComponent(widget.column, widget.row, widget.colSpan, widget.rowSpan));
                this.widgets.push(widget);
            }
        }
    }

    public save(): void {
        app.showWaitPanel();

        let items: IWidgetLayoutItem[] = [];
        for (let widget of this.widgets) {
            items.push(widget.save());
        }
        this.widgetLayout.jsonString = JSON.stringify(items);

        $.ajax({
            type: "POST",
            url: app.resolveUrl("~/api/widget/save"),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(this.widgetLayout),
            success: (result: any) => {
                app.hideWaitPanel();
                this.widgetLayout.id = result.id;
                this.cancel();
            },
            error: ((response) => {
                app.hideWaitPanel();
                app.addError(response.statusText + ": " + response.responseText);
            })
        });
    }

    public addWidget(widget: WidgetBase): void {
        this.widgets.push(widget);
    }

    public isWidgetInside(guid: string, column: number, row: number, colSpan: number, rowSpan: number): boolean {
        for (let widget of this.widgets) {
            if (widget.guid != guid) {
                if (widget.isInside(column, row, colSpan, rowSpan)) {
                    return true;
                }
            }
        }
        return false;
    }

    public isCellFree(column: number, row: number) {
        if (column < 1 || column > this.NUM_COLS) {
            return false;
        }
        if (row < 1 || row > this.NUM_ROWS) {
            return false;
        }
        for (let widget of this.widgets) {
            if (widget.isInside(column, row, 1, 1)) {
                return false;
            }
        }
        return true;
    }

    public hightlightDropItems(column: number, row: number, colSpan: number, rowSpan: number, showHighlight: boolean): void {
        for (let rowIndex = 0; rowIndex < this.NUM_ROWS; rowIndex++) {
            for (let colIndex = 0; colIndex < this.NUM_COLS; colIndex++) {
                if (showHighlight && this.bgWidgets[rowIndex][colIndex].isInside(column, row, colSpan, rowSpan)) {
                    this.bgWidgets[rowIndex][colIndex].element.classList.add("drop-highlight");
                }
                else {
                    this.bgWidgets[rowIndex][colIndex].element.classList.remove("drop-highlight");
                }
            }
        }
    }

    public getCellWidth(): number {
        var rect = this.bgWidgets[0][0].element.getBoundingClientRect();
        return rect.width;
    }

    public getCellHeight(): number {
        var rect = this.bgWidgets[0][0].element.getBoundingClientRect();
        return rect.height;
    }

    public deleteWidget(widget: WidgetBase): void {
        let index = this.widgets.indexOf(widget);
        if (index >= 0) {
            this.widgets.splice(index, 1);
            widget.component.element.parentElement.removeChild(widget.component.element);
        }
    }

    public createWidget(type: WidgetTypes): WidgetBase {
        switch (type) {
            case WidgetTypes.Table:
                return new WidgetTable(this);
            case WidgetTypes.Analyse:
                return new WidgetAnalyse(this);
            case WidgetTypes.Text:
                return new WidgetText(this);
            case WidgetTypes.MeasureText:
                return new WidgetMeasureText(this);
            case WidgetTypes.Image:
                return new WidgetImage(this);
            case WidgetTypes.Links:
                return new WidgetLinks(this);
            case WidgetTypes.WhoIsOnline:
                return new WidgetWhoIsOnline(this);
            case WidgetTypes.Lists:
                return new WidgetLists(this);
            case WidgetTypes.DesignTable:
                return new WidgetDesignTable(this);
            case WidgetTypes.DesignMeasureText:
                return new WidgetDesignMeasureText(this);
            case WidgetTypes.MeasuresByCategory:
                return new WidgetMeasuresByCategory(this);
            case WidgetTypes.Statistic:
                return new WidgetStatistic(this);
            case WidgetTypes.MeasureTree:
                return new WidgetMeasureTree(this);
            case WidgetTypes.MeasuresByStatus:
                return new WidgetMeasuresByStatus(this);
            case WidgetTypes.HasMeasures:
                return new WidgetHasMeasures(this);
            case WidgetTypes.GenericDataTable:
                return new WidgetGenericDataTable(this);
            case WidgetTypes.VideoTutorials:
                return new WidgetVideoTutorials(this);
            case WidgetTypes.Dashboard:
                return new WidgetDashboard(this);
            case WidgetTypes.NewestDocuments:
                return new WidgetNewestDocuments(this);
            case WidgetTypes.UserIsNamed:
                return new WidgetUserIsNamed(this);
        }
    }
}